import React from "react";
import styled, { keyframes } from "styled-components";

const loaderAnimationFrames = keyframes`
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
`;

const StyledLoaderContainer = styled.div`
  position: relative;
  width: 100%;
  .loader {
    position: relative;
    margin: 0 3.5em;
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
    width: 1.7em;
    height: 1.7em;
    animation-fill-mode: both;
    animation: ${loaderAnimationFrames} 1.8s infinite ease-in-out;
  }

  .loader:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 3.5em;
  }
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    top: 0;
  }
`;

const Loader = () => (
  <StyledLoaderContainer>
    <div className="loader">Loading...</div>
  </StyledLoaderContainer>
);

export default Loader;
